import React, { useEffect, useState } from 'react'
import Container from '../../../ui/comp/Container'
import Button from '../../../ui/comp/Button'
import { useMutation, useQuery } from '@tanstack/react-query'
import { Axios } from '../../../utils/Axios'
import toast from 'react-hot-toast'
import FroalaEditor from 'react-froala-wysiwyg'

function Privacy() {
    const [content, setContent] = useState('');
    const [formData, setformData] = useState({ content: "" })


    const setData = (value) => {
        setformData({ ...formData, content: value })
        setContent(value)
    }

    const { data } = useQuery({
        queryKey: ['privacy'],
        queryFn: async () => {
            const res = await Axios.get('/other/privacy')
            return res.data
        }
    })

    useEffect(() => {
        setformData(data)
        setContent(data?.content)
    }, [data])


    // Send Data

    const { mutate, isPending } = useMutation({
        mutationFn: async (formData) => {
            return Axios.post('/other/privacy', formData)
        },
        onError: (error) => {
            toast.error(error?.response?.data || error.message)
        },
        onSuccess: () => {
            toast.success("Successfully")
        }
    })


    const sendData = () => {
        mutate(formData)
        console.log(content);
    }


    return (
        <div className='w-full relative'>
            <Container>
                <div className="mt-5 w-full">
                    <FroalaEditor
                        tag="textarea"
                        model={content}
                        onModelChange={setData}
                    />
                </div>


                {/* button */}
                <div className="mt-7">
                    <Button loading={isPending} onClick={sendData}>Submit</Button>
                </div>
            </Container>
        </div>
    )
}

export default Privacy